export const OPEN_DELETE_FILE_MODAL = 'OPEN_DELETE_FILE_MODAL';
export const CLOSE_DELETE_FILE_MODAL = 'CLOSE_DELETE_FILE_MODAL';

function openDeleteFileModal(fileId) {
  return {
    type: OPEN_DELETE_FILE_MODAL,
    isDeleteFileModalShown: true,
    fileId
  };
}

function closeDeleteFileModal() {
  return {
    type: CLOSE_DELETE_FILE_MODAL,
    isDeleteFileModalShown: false,
    deleteFileResponse: null,
    deleteFileError: null
  };
}

export function showDeleteFileModal(fileId) {
  return (dispatch) => {
    dispatch(openDeleteFileModal(fileId));
  };
}

export function hideDeleteFileModal() {
  return (dispatch) => {
    dispatch(closeDeleteFileModal());
  };
}
